import { call } from "./api.ts";

// Upload links (01-14): Claude's upload_link gives a person a link, /?upload=<token>, that opens the
// board's upload box on an item or one of their notes. The app redeems it once (for that person
// only), then opens the board it's on with ?attach=<num> or ?attach=<num>:<noteId>, and the board
// opens Add screenshots there. The link itself grants nothing: the uploads are checked as any other.

export interface Redeemed {
  org: { id: string; slug: string; kind: string };
  num: number;
  noteId: string | null;
}

export const redeemUploadLink = (token: string) => call<Redeemed>("POST", "/api/upload-links/redeem", { token });

/** The upload link's token in the address, if any. Pure. */
export const uploadToken = (search: string) => new URLSearchParams(search).get("upload")?.trim() || null;

/** Where a redeemed link goes: its board (?org= for a personal one) with ?attach=. Pure. */
export function attachUrl(r: Redeemed): string {
  const q = new URLSearchParams();
  if (r.org.kind !== "company") q.set("org", r.org.slug);
  q.set("attach", r.noteId ? `${r.num}:${r.noteId}` : String(r.num));
  return `/?${q.toString()}`;
}

/** ?attach=12 or ?attach=12:<noteId>: open Add screenshots on that item (or note). Pure. */
export function readAttach(search: string): { num: number; noteId: string | null } | null {
  const v = new URLSearchParams(search).get("attach")?.trim();
  const m = v?.match(/^(\d{1,9})(?::([A-Za-z0-9_-]{1,40}))?$/);
  return m ? { num: Number(m[1]), noteId: m[2] ?? null } : null;
}

/** The address without one parameter. Pure. */
export function withoutParam(search: string, key: string): string {
  const q = new URLSearchParams(search);
  q.delete(key);
  const s = q.toString();
  return s ? `?${s}` : "";
}
